import { makeStyles } from '@rbx/ui';

const useMarkdownTabsStyles = makeStyles()({
  tabs: {
    marginBottom: '16px',
  },
});

export default useMarkdownTabsStyles;
